export default __webpack_public_path__ + "static/media/frame-card-chieftain.3724c5f6.png";